module.exports = __webpack_public_path__ + "media/images/category/dummy/accessory01-fd70318ad12b8847081d1719c7871597.jpg";